import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Bookmark, BookmarkCheck } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function BookmarkButton({ articleId, variant = "outline", size = "icon", className = "" }) {
  const { user } = useAuth();
  const [bookmarked, setBookmarked] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user || !articleId) return;
    api.get(`/bookmarks/check/${articleId}`).then(r => setBookmarked(r.data.bookmarked)).catch(() => {});
  }, [user, articleId]);

  const toggle = async () => {
    if (!user) {
      toast.error("Login to bookmark articles");
      return;
    }
    setLoading(true);
    try {
      if (bookmarked) {
        await api.delete(`/bookmarks/${articleId}`);
        setBookmarked(false);
        toast.success("Removed from reading list");
      } else {
        await api.post("/bookmarks", { article_id: articleId });
        setBookmarked(true);
        toast.success("Added to reading list");
      }
    } catch { toast.error("Failed to update bookmark"); }
    setLoading(false);
  };

  return (
    <Button
      variant={variant}
      size={size}
      className={`${className} ${bookmarked ? "text-[#1E88E5] border-[#1E88E5]" : ""}`}
      onClick={toggle}
      disabled={loading}
      data-testid={`bookmark-btn-${articleId || "main"}`}
    >
      {bookmarked ? <BookmarkCheck className="h-4 w-4" /> : <Bookmark className="h-4 w-4" />}
    </Button>
  );
}
